// extracted by mini-css-extract-plugin
export var container = "_6j-0";
export var containerTopRight = "_6j-1";